import { AppRoutes } from '../../../Core/App/AppRoutes';
import { AppRouteType } from '../../Components/Templates/AppRouter/AppRouteType';
import { PrivateRoute } from '../../Components/Templates/AppRouter/PrivateRoute';
import { LoadableControleCreatePage } from '../../Pages/Controles/ControleCreate/LoadableControleCreatePage';
import { LoadableControleListPage } from '../../Pages/Controles/ControleList/LoadableControleListPage';
import { LoadableControleListTodayPage } from '../../Pages/Controles/ListControleToday/LoadableControleListTodayPage';
import { LoadableControleDetailsPage } from '../../Pages/Controles/ControleDetails/LoadableControleDetailsPage';

const getListControleToday = (props: object): AppRouteType => ({
    id: AppRoutes.CONTROLE_TODAY,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.CONTROLE_TODAY,
        component: LoadableControleListTodayPage,
        ...props,
    },
});

const getListControle = (props: object): AppRouteType => ({
    id: AppRoutes.CONTROLE_LIST,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.CONTROLE_LIST,
        component: LoadableControleListPage,
        ...props,
    },
});

const getControleCreate = (props: object): AppRouteType => ({
    id: AppRoutes.CONTROLE_CREATE,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.CONTROLE_CREATE,
        component: LoadableControleCreatePage,
        ...props,
    },
});

const getControleDetails = (props: object): AppRouteType => ({
    id: AppRoutes.CONTROLE_DETAILS,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.CONTROLE_DETAILS,
        component: LoadableControleDetailsPage,
        ...props,
    },
});

export const getControleRoutes = (args: object) => [
    getListControleToday(args),

    getListControle(args),
    getControleCreate(args),
    getControleDetails(args),
];
